module.exports = __webpack_public_path__ + "static/img/solution_soothing.631fcfa9.png";